module.exports = __webpack_public_path__ + "img/banner-lm-1.bd933d20.jpg";